module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-09-22 at 8.55.27 PM.2e0880b4.jpeg";